import { render, staticRenderFns } from "./AuctionsPage.vue?vue&type=template&id=19cc389c"
import script from "./AuctionsPage.vue?vue&type=script&lang=js"
export * from "./AuctionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports